var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInvalidWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.47 4.78 11.625 11.625 1.06-1.06L3.53 3.72 2.47 4.78zM9.806 3.875c-1.635 0-2.672.632-3.29 1.24l1.06 1.06c.394-.382 1.086-.8 2.23-.8.992 0 1.633.438 2.044 1 .433.593.606 1.324.591 1.814a.908.908 0 0 0 .905.936h.21c.398 0 1 .11 1.475.41.435.274.774.704.774 1.465 0 1.24-.636 1.887-1.271 2.133l1.111 1.111c.922-.573 1.66-1.641 1.66-3.244 0-1.34-.66-2.221-1.475-2.735-.634-.399-1.35-.574-1.92-.624a4.711 4.711 0 0 0-.85-2.15c-.662-.907-1.733-1.616-3.254-1.616zM9.348 13.25l1.5 1.5H6.085c-1.108.082-3.03-.285-4.339-1.75C.742 11.876.458 10.66.59 9.58c.127-1.05.64-1.94 1.186-2.485.243-.243.513-.448.798-.62L3.68 7.582a2.97 2.97 0 0 0-.844.573c-.33.33-.675.916-.758 1.605-.08.658.074 1.443.787 2.24.928 1.04 2.362 1.316 3.128 1.253l.031-.003h3.324z",
    fill: "#313030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvalidWeather);
export default __webpack_public_path__ + "static/media/ic_invalid-weather.50bf6fc55b70c6921324e46e49c18688.svg";
export { ForwardRef as ReactComponent };